module.exports = __webpack_public_path__ + "img/fi-rr-angle-double-left.9916ab1f.svg";